import React, { useState } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useExpanded,
  useGlobalFilter,
  useRowSelect,
} from "react-table";
import { AGGREGATE_ETA_DATA_COLUMNS } from "../../columns/aggregateEtaColumns";
import TractorEtaActionCenter from "../action-center/TractorEtaActionCenter";
import AggregateEtaActionCenter from "../action-center/AggregateEtaActionCenter";
import { filter } from "lodash";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import { TableCheckbox } from "./TableCheckbox";

function AggregateEtaDataTable({
  tableData,
  date,
  setDate,
  setShowDailyPlanUploader,
  dataExportHandler,
  subModule,
  filteredUserAccessData,
  noDataState,
  setNoDataState,
  setCarrierList,
  aggregateETATemplateDownloader
  // setCopyData
}) {
  const [columns] = useState(AGGREGATE_ETA_DATA_COLUMNS);
  // const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [showDisableCellForJD, setShowDisableCellForJD] = useState(false);

  var allowToEdit = filter(filteredUserAccessData, { Edit: 1 }).length > 0;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    selectedFlatRows,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data: tableData,
      autoResetPage: false,
      initialState: { pageSize: 50 },
      autoResetExpanded: false,
      autoResetGlobalFilter: false,
      showDisableCellForJD,
      setShowDisableCellForJD,
      // newSelectedFlatRows,
      allowToEdit,
      // setCopyData
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) =>
            // showCheckbox(row) && (
              <div>
                <TableCheckbox {...row.getToggleRowSelectedProps()} />
              </div>
            // ),
        },
        ...columns,
      ]);
    }
  );

  const { pageIndex, pageSize, globalFilter } = state;

  return (
    <>
      <div className="table_actionsforTransporter">
        {/* <Form.Group>
          <Form.Control
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="hiden-inp"
            placeholder="search here.."
          />
        </Form.Group> */}
        <AggregateEtaActionCenter
          date={date}
          setDate={setDate}
          setShowDailyPlanUploader={setShowDailyPlanUploader}
          dataExportHandler={dataExportHandler}
          selectedFlatRows={selectedFlatRows}
          subModule={subModule}
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          type={"AggregateETA"}
          filteredUserAccessData={filteredUserAccessData}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          setNoDataState={setNoDataState}
          setCarrierList={setCarrierList}
          aggregateETATemplateDownloader={aggregateETATemplateDownloader}
        />
      </div>
      {!noDataState && (
        <>
          <div className="table_container">
            <table {...getTableProps()} className="table mtbs">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className="transporter_table_class"
                      >
                        {column.render("Header")}
                        {column.id !== "selection" && (
                          <i
                            className={
                              column.isSorted
                                ? column.isSortedDesc
                                  ? "fi fi-rr-angle-small-down head-icon"
                                  : "fi fi-rr-angle-small-up head-icon"
                                : "fi fi-rr-circle-small head-icon w"
                            }
                          ></i>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={
                              cell.row.subRows.length !== 0
                                ? "main-row"
                                : "sub-row"
                            }
                          >
                            <div className="cell-wrap">
                              {cell.render("Cell")}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* <MainTablePagination
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
      /> */}
          <MainTablePaginationAdv
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            setPageSize={setPageSize}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
        </>
      )}
    </>
  );
}

export default AggregateEtaDataTable;
